/**
 * Created by JIocb on 23.06.2017.
 */

module Factive.Core
{
    "use strict"
    import Signal = Factive.Core.Signal.Signal;
    import Armature = dragonBones.Armature;
    import DragonBonesButton = Factive.Game.DragonBonesButton;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import Slot = dragonBones.Slot;
    import HelpPageView = Factive.Game.HelpPageView;
    import LocalizationConstants = Arkadium.Game.Localization.LocalizationConstants;

    export class HelpPanel extends Panel
    {
        private static SLOT_PANEL_HELP_PAGE_123:string = "Panel_Help_Page_123";
        private static SLOT_PANEL_HELP_PAGE_4:string = "Panel_Help_Page_4";
        private static SLOT_PANEL_HELP_PAGE_5:string = "Panel_Help_Page_5";
        private static SLOT_PANEL_HELP_PAGE_6:string = "Panel_Help_Page_6";

        private _lm:LocalizationManager;
        private _armature:dragonBones.Armature;

        private _closeBtn:DragonBonesButton;
        private _prevBtn:DragonBonesButton;
        private _nextBtn:DragonBonesButton;

        private _currentPageView:HelpPageView;
        private _currentPageNum:number;
        private _maxPagesNum:number;

        private _title:PIXI.Text;
        private _closeBtnArmature: Armature;

        constructor(dc:DependenciesContainer, name:any)
        {
            super(dc, name);

            this._lm = this._dc.get("LocalizationManager");

            this._maxPagesNum = 6;
            this._currentPageNum = 1;
        };

        protected build():void
        {
            "use strict";

            this._armature = dragonBones.PixiFactory.factory.buildArmature("Panel_Help");
            this.addChild(<PIXI.DisplayObject>this._armature.display);

            this.buildButtons();
            this.buildTitle();
            this.showHelpPage(this._currentPageNum);
        };

        protected showHelpPage(pageNumber:number):void
        {
            this.removeCurrentPageView();
            this.showChildArmatures(false);

            let slotName:string;
            let childArmature:Armature;

            switch(pageNumber)
            {
                case 1:
                case 2:
                case 3:
                    slotName = HelpPanel.SLOT_PANEL_HELP_PAGE_123;
                    break;
                case 4:
                    slotName = HelpPanel.SLOT_PANEL_HELP_PAGE_4;
                    break;
                case 5:
                    slotName = HelpPanel.SLOT_PANEL_HELP_PAGE_5;
                    break;
                case 6:
                    slotName = HelpPanel.SLOT_PANEL_HELP_PAGE_6;
                    break;
            }

            childArmature = this._armature.getSlot(slotName).childArmature;
            childArmature.display.visible = true;
            this._currentPageView = new HelpPageView(childArmature, this._dc, this._currentPageNum);

            this.updateTitle();
            this.toggleArrowsVisibility();
        }

        private showChildArmatures(show:boolean)
        {
            let names:Array<string> =
                [
                    HelpPanel.SLOT_PANEL_HELP_PAGE_123,
                    HelpPanel.SLOT_PANEL_HELP_PAGE_4,
                    HelpPanel.SLOT_PANEL_HELP_PAGE_5,
                    HelpPanel.SLOT_PANEL_HELP_PAGE_6
                ];

            for(let i:number = 0; i < names.length; i++)
            {
                let name:string = names[i];
                this._armature.getSlot(name).childArmature.display.visible = false;
            }
        }

        protected updateTitle():void
        {
            this._title.text = this._lm.getText(LocalizationConstants.HELP_TITLE) + " " + this._currentPageNum + "/" + this._maxPagesNum;
        }

        protected handlePressPrevBtn():void
        {
            if(this._currentPageNum <= 1)
            {
                return;
            }
            this._currentPageNum--;

            this.showHelpPage(this._currentPageNum);

            this.toggleArrowsVisibility();
        }

        protected handlePressNextBtn():void
        {
            if(this._currentPageNum >= this._maxPagesNum)
            {
                return;
            }
            this._currentPageNum++;

            this.showHelpPage(this._currentPageNum);

            this.toggleArrowsVisibility();
        }

        private toggleArrowsVisibility():void
        {
            if(this._currentPageNum == this._maxPagesNum)
            {
                this._nextBtn.enableInput(false);
            }
            else
            {
                if(this._currentPageNum == 1)
                {
                    this._prevBtn.enableInput(false);
                }
                else
                {
                    this._nextBtn.enableInput(true);
                    this._prevBtn.enableInput(true);
                }
            }
        }

        private handlePressCloseBtn():void
        {
            this.sendEvent(EventBusConstants.EVENT_HELP_PANEL_REQUESTS_TO_CLOSE,EventBusConstants.TOPIC_UI);
        }

        protected buildTitle():void
        {
            this._title = new PIXI.Text("", <PIXI.TextStyle>{
                fontFamily:'Bold',
                fontSize:22* this._assetScale,
                fill:'#1B4F5A',
                align:"center"
            });
            this._title.anchor.set(.5, 0);
            this._armature.getSlot("title").display = this._title;
            this._armature.getSlot("title").display.x += (15* this._assetScale);
        }

        protected buildButtons():void
        {
            this._closeBtnArmature = this._armature.getSlot("CloseBtn").childArmature;
            this._closeBtn = new DragonBonesButton(this._closeBtnArmature, this._dc);
            this._closeBtn.addPressListener(this.handlePressCloseBtn, this);

            let btnArmature = this._armature.getSlot("PrevBtn").childArmature;
            this._prevBtn = new DragonBonesButton(btnArmature, this._dc);
            this._prevBtn.addLabel(this._lm.getText("prev"), 0, 0, <PIXI.TextStyle>{
                fontFamily:'Medium',
                fontSize:20* this._assetScale,
                fill:'#FFFFFF',
                align:"center"
            });
            this._prevBtn.addPressListener(this.handlePressPrevBtn, this);

            btnArmature = this._armature.getSlot("NextBtn").childArmature;
            this._nextBtn = new DragonBonesButton(btnArmature, this._dc);
            this._nextBtn.addLabel(this._lm.getText("next"), 0, 0, <PIXI.TextStyle>{
                fontFamily:'Medium',
                fontSize:20* this._assetScale,
                fill:'#FFFFFF',
                align:"center"
            });
            this._nextBtn.addPressListener(this.handlePressNextBtn, this);

            this._calculateScale();
        }

        protected removePressListeners():void
        {
            if(this._prevBtn)
            {
                this._prevBtn.removePressListener(this.handlePressPrevBtn, this);
            }

            if(this._nextBtn)
            {
                this._nextBtn.removePressListener(this.handlePressNextBtn, this);
            }
        }

        protected removeCurrentPageView():void
        {
            if(this._currentPageView)
            {
                this._currentPageView.destroy();
                this._currentPageView = null;
            }
        }

        public reset():void
        {
            this.removeCurrentPageView();
            this.removePressListeners();

            if(this._prevBtn)
            {
                this._prevBtn.destroy();
                this._prevBtn = null;
            }

            if(this._nextBtn)
            {
                this._nextBtn.destroy();
                this._nextBtn = null;
            }

            if(this._title)
            {
                this._title.destroy();
                this._title = null;
            }

            if(this._armature)
            {
                this.removeChild(<PIXI.DisplayObject>this._armature.display);
                this._armature = null;
            }

            super.reset();
        }

        public destroy():void
        {
            if(this._lm)
            {
                this._lm = null;
            }

            super.destroy();
        }

        protected _calculateScale(){
            if(this._aspectRatio == "landscape")
            {
                this._closeBtnArmature.display.scale.x = this._closeBtnArmature.display.scale.y = 1;
            }
            else if(this._aspectRatio == "portrait")
            {
                this._closeBtnArmature.display.scale.x = this._closeBtnArmature.display.scale.y = 1.8;
            }
        }

        public resize(aspectRatio: string){
            super.resize(aspectRatio);
            if(this._armature == null){
                return;
            }
            this._calculateScale();
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/HelpPanel.ts